// utils/auth.js
export const isAuthenticated = () => {
    // Example check, you might check for a token in localStorage or context
    return !!localStorage.getItem('token');
  };
  